import { useQuery } from "@tanstack/react-query";

import { ListMapIntegrationPlansQueryFilters, UseListMapIntegrationPlansQueryOptions } from "./types";
import { getMapIntegrationPlansService } from "./service";

export const listMapIntegrationPlansQueryKey = ["subscription_mapintegrationplan_admin"];

export function useListMapIntegrationPlansQuery(
  filters?: ListMapIntegrationPlansQueryFilters,
  options?: UseListMapIntegrationPlansQueryOptions
) {
  const queryKey = listMapIntegrationPlansQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getMapIntegrationPlansService(filters),
    ...options,
  });
}
